import config from "config";
import gsap from "gsap";
import AssetsManager from "js/components/AssetsManager";
import GameManager from "js/components/GameManager";
import { Container, Sprite, TextStyle, Text } from "pixi.js";
import tools from "tools";

export default class Arrows extends Container {

    constructor() {

        super();

        tools.autobind(this);

        this._cpt = 0;
        this._scale = .6;

        this._down = false;
        this._access = true;
        this._lockRV = false;

        this._init();
        this._initEvents();
    }

    _init() {

        this.btn = new Sprite.from(AssetsManager.texturesPixi.arrowBtn);
        this.btn.scale.set(this._scale);
        this.btn.anchor.set(.5);
        this.addChild(this.btn);

        this.rv = new Sprite.from(AssetsManager.texturesPixi.boosterRv);
        this.rv.anchor.set(.5, 1.3);
        this.rv.scale.set(.75);
        this.rv.y = this.btn.height;
        this.btn.addChild(this.rv);

        const style = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 35,
            fill: '#ffffff',
            stroke: '#000000',
            strokeThickness: 4
        });

        this.cptText = new Text(this._cpt, style);
        this.cptText.anchor.set(.5);
        this.cptText.y = this.btn.height - 42;
        this.cptText.visible = false;
        this.btn.addChild(this.cptText);

        if(tools.setupIs().desktop){
            this.controlText = new Text('B', style);
            this.controlText.anchor.set(1,.5);
            this.controlText.y = 0;
            this.controlText.x = -this.btn.height/2 - 2;
            this.btn.addChild(this.controlText);
        }

        this.visible = false;

    }



    _initEvents() {

        this.btn.interactive = true;
        this.btn.buttonMode = true;

        this.btn.on('pointerdown', this.onDown);
        this.btn.on('pointerup', this.onUp);
        this.btn.on('pointerupoutside', this.onOut);
    }


    onDown(event) {

        if (config.gameStarted && this._access && !this._down && !GameManager.ball.isBooster && !GameManager.ball.isShielded && !GameManager.GAME.isLose) {
            this._down = true;
            gsap.to(this.btn.scale, { duration: .2, x: this._scale - .07, y: this._scale - .07 });
            // console.log(this._label, " onDown");
        }
    }

    onUp(event) {

        if (config.losePlatformTouched) {
            return;
        }

        if (this._down) {
            // console.log(this._label, " onUp");
            gsap.to(this.btn.scale, { duration: .2, x: this._scale, y: this._scale });

            if (this._cpt > 0) {
                this._cpt--;
                // GameManager.H5SDK.saveProgression("arrowBooster", this._cpt);
                // console.log(">>> saveProgression arrowBooster");
                this.cptText.text = this._cpt;
                if (this._cpt <= 0) {
                    this.cptText.visible = false;
                    this.rv.visible = true;
                }
                this._access = false;
                gsap.delayedCall(2, () => {
                    this._access = true;
                });

                GameManager.platforms.touchBoostArrow();

            } else {
                if(!this._lockRV){
                    this._lockRV = true;
                    GameManager.pause();
                    this.requestRewarded(result => {
                        result && this.add();
                        GameManager.resume();
                        this._lockRV = false;
                    });
                }
                
            }

        }
        this._down = false;

    }

    set cpt(value) {
        // value = 5;
        this._cpt = value;
        this.cptText.text = this._cpt;

        if (this._cpt > 0) {
            this.cptText.visible = true;
            this.rv.visible = false;
        }
    }

    get getBtn() {
        return this.btn;
    }

    onOut(event) {
        this._down = false;
        gsap.to(this.btn.scale, { duration: .2, x: this._scale, y: this._scale });

    }

    add() {
        this._cpt++;
        // GameManager.H5SDK.saveProgression("arrowBooster", this._cpt);
        // console.log(">>> saveProgression arrowBooster");
        this.cptText.text = this._cpt;
        this.cptText.visible = true;
        this.rv.visible = false;
        gsap.to(this.btn.scale, { duration: .2, x: this._scale + .2, y: this._scale + .2 });
        gsap.to(this.btn.scale, { delay: .3, duration: .2, x: this._scale, y: this._scale });

        gsap.to(this.cptText.scale, { duration: .2, x: 2, y: 2 });
        gsap.to(this.cptText.scale, { delay: .3, duration: .3, x: 1, y: 1 });

    }

    save() {
        GameManager.H5SDK.getStoreModule().save("arrowBooster", this._cpt);
        // console.log(">>> saveProgression arrowBooster");
    }

    notifyLevelStart() {
        // Show the bonus items
        this.visible = true;
        this.btn.scale.set(0);
        gsap.to(this.btn.scale, {
            delay: .1,
            duration: .6,
            x: this._scale,
            y: this._scale,
            ease: "back.out(2)"

        })
        this._lockRV = false;
    }


    async requestRewarded(callback) {
        const result = await GameManager.H5SDK.getAdsModule().requestRewardedAd();
        callback(result);
    }

    resize(w, h, coef) {
        this.btn.x = w - this.btn.width / 2 - 5;

        if (coef < 1) {
            this.btn.y = h / 2 + this.btn.height + 14;
        } else {
            this.btn.y = h / 2 + this.btn.height;
        }
    }

    update() {

    }
}